module.exports = __webpack_public_path__ + "img/Small-Bevel-Attachment-42.e300efb1.png";